<template>

    <v-select :size="size" :model="val" @input="$emit('input', $event)">
        <option value="American Typewriter, serif">American Typewriter</option>
        <option value="Andale Mono, monospace">Andale Mono</option>
        <option value="Arial, sans-serif">Arial</option>
        <option value="Arial Narrow, sans-serif">Arial Narrow</option>
        <option value="Avantgarde, TeX Gyre Adventor, URW Gothic L, sans-serif">Avant Garde</option>
        <option value="Bookman, URW Bookman L, serif">Bookman</option>
        <option value="Bradley Hand, cursive">Bradley Hand</option>
        <option value="Courier, monospace">Courier</option>
        <option value="Courier New, monospace">Courier New</option>
        <option value="Didot, serif">Didot</option>
        <option value="Georgia, serif">Georgia</option>
        <option value="Gill Sans, sans-serif">Gill Sans</option>
        <option value="Helvetica, sans-serif">Helvetica</option>
        <option value="New Century Schoolbook, TeX Gyre Schola, serif">New Century Schoolbook</option>
        <option value="Noto Sans, sans-serif">Noto Sans</option>
        <option value="Optima, sans-serif">Optima</option>
        <option value="Palatino, URW Palladio L, serif">Palatino</option>
        <option value="Snell Roundhand, cursive">Snell Roundhand</option>
        <option value="Times, Times New Roman, serif">Times New Roman</option>
        <option value="Trebuchet MS, sans-serif">Trebuchet MS</option>
        <option value="Verdana, sans-serif">Verdana</option>
    </v-select>

</template>

<script>

export default {

    props: {
        model: {
            required: true,
        },
        size: {
            type: String,
            default: 'md',
        },
    },

    data() {
        return {
            val: this.model.replace(/['"]+/g, ''),
        }
    },

}

</script>
